// export const API_URL = 'https://ftmo-api-dev.buso.asia';
// export const API_URL = 'https://ftmo-real-api.buso.asia';

const is_local = false; // Set to true for local development

export const API_URL = is_local ? 'http://192.168.1.103/rewards' : 'https://api.ccpi.vn/rewards';
export const API_USER_URL = is_local ? 'http://192.168.1.103/users' : 'https://api.ccpi.vn/users';

//export const API_URL = is_local ? 'https://reward-service.ccpi.vn' : 'https://reward-api.buso.asia';
//export const API_USER_URL = is_local ? 'https://user-service.ccpi.vn' : 'https://reward-api-user.buso.asia';

// export const API_URL = 'https://0c8214ed97c8.ngrok-free.app'
export const API_URL_3 = 'https://78534d12e343.ngrok-free.app';
export const BOT_ZIGZAG_URL = 'http://localhost:3000';
export const INDEX_SENTIMENT_URL = 'https://chart.index.wealthfarming.org/';


export const DOMAIN_API = 'beq.busodevelopers.com'
export const SITE_ID = 343
export const API_URL_v2 = 'https://fund-forge-api.wealthfarming.org';

export const API_URL_IMAGE = 'http://beq-image.buso.asia';
export const LIMIT_EXPORT_EXCEL = 10000
export const API_GET_IMAGE = ''

export const CRM_HOST = 'https://crm.beqholdings.com';
export const SIGNING_CONTRACT_HASH_KEY = 'BEQ_SIGNING_CONTRACT_2026'; // Replace with a secure key in production
export const REACT_APP_PAYPAL_MODE = 'sandbox' // sandbox for dev, live for real
export const BOT_TELEGRAM = 'sandbox' // sandbox for dev, live for real

export const Web3_ENV: "testnet" | "mainnet" = 'testnet' // testnet for dev, mainnet for real
